export const defaultShipmentData = {
  shipment_number: '',
  entry_date: '',
  client: '',
  carrier: '',
  chartering_date: '',
  last_order_date: '',
  pickup_date: '',
  delivery_date: '',
  pickup_postcode: '',
  delivery_postcode: '',
  number_of_pallets: null,
  weight: '',
  client_price: null,
  client_vat: 0,
  client_total: 0,
  carrier_price: null,
  carrier_email: '',
  carrier_vat: 0,
  carrier_total: 0,
  margin: 0,
  margin_rate: 0,
  pickup_day_when: '',
  pickup_time_when: 'AVANT',
  pickup_hour: '',
  pickup_name: '',
  pickup_address1: '',
  pickup_address2: '',
  pickup_city: '',
  pickup_reference: '',
  pickup_contact: '',
  delivery_day_when: '',
  delivery_time_when: 'AVANT',
  delivery_hour: '',
  delivery_name: '',
  delivery_address1: '',
  delivery_address2: '',
  delivery_city: '',
  delivery_reference: '',
  delivery_contact: '',
  shipment_reference: '',
  pallet_type: '80 x 120',
  pallet_height: null,
  footage: null,
  pallet_exchanger: false,
  number_of_exchangers: null,
  semi_taut: false,
  porteur_taut: false,
  semi_fourgon: false,
  porteur_fourgon: false,
  semi_frigo: false,
  porteur_frigo: false,
  vingt_metres_cube: false,
  vingt_metres_cube_frigo: false,
  plateau: false,
  tail_lift: false,
  pallet_truck: false,
  adr: false,
  class_type: '',
  un_code: '',
  grp: '',
  comments: '',
  has_dispute: false,
  internal_comments: '',
  markers: '',
  history: '',
  shipment_stage: 'A TRAITER',
  invoicing_status: '',
  shipment_is_active: true,
};

export const defaultClientData = {
  client_code: '',
  creation_date: '',
  updated_at: '',
  name: '',
  establishment_postcode: '',
  establishment_city: '',
  establishment_phone1: '',
  establishment_phone2: '',
  establishment_email: '',
  establishment_address1: '',
  establishment_address2: '',
  establishment_country: '',
  establishment_contact: '',
  establishment_fax: '',
  pickup_name: '',
  pickup_postcode: '',
  pickup_city: '',
  pickup_phone1: '',
  pickup_phone2: '',
  pickup_email: '',
  pickup_address1: '',
  pickup_address2: '',
  pickup_country: '',
  pickup_contact: '',
  pickup_fax: '',
  billing_name: '',
  billing_postcode: '',
  billing_city: '',
  billing_phone1: '',
  billing_phone2: '',
  billing_email: '',
  billing_address1: '',
  billing_address2: '',
  billing_country: '',
  billing_contact: '',
  billing_fax: '',
  email_book: '',
  default_emails: [],
  address_book: '',
  siret_number: '',
  vat_number: '',
  ape_naf_code: '',
  payment_type: '',
  period: '',
  diesel_tax: '',
  vat_status: true,
  pickup_delivery: false,
  payment_time_from_billing: 30,
  automatic_billing: false,
  semi_taut: false,
  porteur_taut: false,
  semi_fourgon: false,
  porteur_fourgon: false,
  semi_frigo: false,
  porteur_frigo: false,
  vingt_metres_cube: false,
  vingt_metres_cube_frigo: false,
  plateau: false,
  tail_lift: false,
  pallet_truck: false,
  pallet_exchanger: false,
  adr: false,
  class_type: '',
  un_code: '',
  grp: '',
  comments: '',
  completed_shipments_last_year: 0,
};

export const defaultCarrierData = {
  carrier_code: '',
  creation_date: '',
  updated_at: '',
  name: '',
  establishment_postcode: '',
  establishment_city: '',
  establishment_phone1: '',
  establishment_phone2: '',
  establishment_email: '',
  establishment_address1: '',
  establishment_address2: '',
  establishment_country: '',
  establishment_contact: '',
  establishment_fax: '',
  email_book: '',
  cmr_email: '',
  billing_name: '',
  billing_postcode: '',
  billing_city: '',
  billing_phone1: '',
  billing_phone2: '',
  billing_email: '',
  billing_address1: '',
  billing_address2: '',
  billing_country: '',
  billing_contact: '',
  billing_fax: '',
  siret_number: '',
  vat_number: '',
  ape_naf_code: '',
  payment_type: '',
  period: '',
  vat_status: true,
  display_all_in: false,
  pickup_departments: '',
  delivery_departments: '',
  semi_taut: '',
  porteur_taut: '',
  semi_fourgon: '',
  porteur_fourgon: '',
  semi_frigo: '',
  porteur_frigo: '',
  vingt_metres_cube: '',
  vingt_metres_cube_frigo: '',
  plateau: '',
  is_blacklisted: false,
  is_favorite: false,
  completed_shipments_last_year: 0,
  diesel_tax: '',
  payment_deadline: '',
};
